import React, { useEffect, useState } from 'react';
import { Select, Spin } from 'antd';
import { useAuth } from '../context/AuthContext';
import API_URL from '../config/api';
import { apiFetch } from '../utils/apiFetch';

interface Business {
  id: string;
  name: string;
}

const BusinessSwitcher: React.FC = () => {
  const { token, business_id, login, role } = useAuth();
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    apiFetch(`${API_URL}/admin/businesses`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        const businessArray = Array.isArray(data) ? data : (data?.businesses || (data ? [data] : []));
        setBusinesses(businessArray);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [token]);

  const handleSwitch = (id: string) => {
    // Find the business and switch context
    login(token!, role, id);
    window.location.reload();
  };

  if (!token || !role || (role !== 'SuperAdmin' && role !== 'Admin')) return null;
  if (loading) return <Spin size="small" style={{ marginLeft: 16 }} />;
  if (businesses.length <= 1) return null;

  return (
    <Select
      value={business_id}
      onChange={handleSwitch}
      style={{ minWidth: 180, marginLeft: 16 }}
      size="small"
      options={businesses.map(b => ({ value: b.id, label: b.name }))}
    />
  );
};

export default BusinessSwitcher;
